import { GroupService } from "./GroupService";

export { GroupService };
